import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

interface ChartLoadingProps {
  label?: string;
}

export function ChartLoading({ label = "Loading chart data" }: ChartLoadingProps) {
  return (
    <Box
      role="status"
      aria-label={label}
      sx={{
        minHeight: 220,
        display: "grid",
        placeItems: "center",
        gap: 1,
      }}
    >
      <CircularProgress size={28} />
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
    </Box>
  );
}
